import * as React from 'react';
import s from './articleFooter.scss';
import ArticleLabels from '../ArticleLabels';
import {Experiment} from '../../../reducers/experiments';

interface ArticleFooterProps {
  labels: any[];
  withMedia?: boolean;
  articleId: string;
  experiments?: Experiment[];
}
type ArticleFooterState = {
  link: string
};
class ArticleFooter extends React.Component<ArticleFooterProps, ArticleFooterState> {
  constructor(props) {
    super(props);
    this.state = {
      link: ''
    };
  }
  componentDidMount() {
    this.setState({
      link: `${location.origin}/${window.__BASEURL__}/article/${
        this.props.articleId
      }`
    });
  }
  render() {
    const {labels, withMedia, articleId, experiments} = this.props;
    return (
      <div className={`${s.footer} ${withMedia ? s.media : ''}`}>
        <ArticleLabels labels={labels} articleId={articleId} experiments={experiments} />
      </div>
    );
  }
}
export default ArticleFooter;
